import { useMutation } from "@apollo/client";

import { USER_GET_BY_ID } from "~/modules/user/api/useUserGetById";

import { COURSE_GET_ALL } from "../../CourseListRoute/api/useCourseListRoute_GetAll";
import { CourseEditRoute_UserCreateDocument } from "../mutations.generated";

export default function useUserCourseCreate() {
    const [createUserCourseMutation, { loading, error, data }] = useMutation(CourseEditRoute_UserCreateDocument, {
        refetchQueries: [USER_GET_BY_ID, COURSE_GET_ALL],
    });

    const createUserCourse = async (input: { userId: string; courseId: string }): Promise<void> => {
        await createUserCourseMutation({
            variables: { input },
        });
    };

    return {
        loading,
        error,
        data: data?.courseAddToUser,
        createUserCourse,
    };
}
